import type { RowSelectionState } from '@tanstack/react-table';

export function getRowIds(rowSelection: RowSelectionState) {
    return Object.entries(rowSelection)
        .filter(([_key, value]) => {
            return value;
        })
        .map(([key, _value]) => {
            return key;
        });
}

export function getRowRecords(rowSelection: string[]) {
    return rowSelection.reduce(
        (acc, value) => {
            acc[value] = true;

            return acc;
        },
        {} as Record<string, boolean>
    );
}
